module.exports = __webpack_public_path__ + "img/MobileMenu.9ce0b0aa.svg";